import { render, staticRenderFns } from "./NavList.vue?vue&type=template&id=5091abc2&scoped=true&"
import script from "./NavList.vue?vue&type=script&lang=js&"
export * from "./NavList.vue?vue&type=script&lang=js&"
import style0 from "./NavList.vue?vue&type=style&index=0&id=5091abc2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5091abc2",
  null
  
)

export default component.exports